import { render, staticRenderFns } from "./communityContentData.vue?vue&type=template&id=56ef35c8&scoped=true&"
import script from "./communityContentData.vue?vue&type=script&lang=js&"
export * from "./communityContentData.vue?vue&type=script&lang=js&"
import style0 from "./communityContentData.vue?vue&type=style&index=0&id=56ef35c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef35c8",
  null
  
)

export default component.exports